/* Elora — sticky add-to-cart bar. Appears once the buy box is above the fold,
   hides while the buy box, the CTA band, the community CTA or the footer is on screen.
   Price, compare price, line under the name and availability follow the card selected in the
   buy box (window.Elora.selection, kept by elora-pdp.js and broadcast as `elora:selection`),
   so the bar always shows exactly what its button submits. */
(function () {
  var Elora = (window.Elora = window.Elora || {});

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function buyTarget() {
    return document.querySelector('[data-elora-buy]') || document.querySelector('#buy');
  }

  function applySelection(bar, sel) {
    if (!sel) return;
    var price = bar.querySelector('.sbar__p');
    var old = bar.querySelector('.sbar__o');
    var line = bar.querySelector('.sbar__var');
    var btn = bar.querySelector('[data-elora-sbar-btn]');
    var label = btn && btn.querySelector('.sbar__t');
    if (price && sel.price) price.textContent = sel.price;
    if (old) {
      old.textContent = sel.compare || '';
      old.hidden = !sel.compare;
    }
    if (line && sel.title) line.textContent = sel.title;
    /* The compact label only abbreviates an unqualified percentage already supplied by the card.
       Other formats retain their full text in a separate row; no discount is recalculated here. */
    var save = bar.querySelector('[data-sbar-save]');
    if (save) {
      var badge = (sel.badge || '').trim();
      var percent = badge.match(/^(?:(?:Oszczędzasz|Save)\s+|[−-]\s*)(\d+(?:[.,]\d+)?)\s*%$/i);
      var saveText = save.querySelector('[data-sbar-save-text]');
      var saveLabel = save.querySelector('[data-sbar-save-label]');
      if (saveText) saveText.textContent = percent ? '−' + percent[1] + '%' : badge;
      if (saveLabel) saveLabel.textContent = badge;
      save.title = badge;
      save.classList.toggle('sbar__save--full', !!badge && !percent);
      save.hidden = !badge;
    }
    if (btn) {
      var available = sel.available !== false;
      btn.disabled = !available;
      bar.classList.toggle('is-unavailable', !available);
      if (label) label.textContent = available ? (btn.dataset.labelAdd || label.textContent) : (btn.dataset.labelSoldOut || label.textContent);
      var mobile = btn.querySelector('.sbar__tm');
      if (mobile) mobile.textContent = available ? (btn.dataset.labelAddMobile || btn.dataset.labelAdd || mobile.textContent) : (btn.dataset.labelSoldOut || mobile.textContent);
    }
  }

  function initRoot(bar) {
    if (bar.hasAttribute('data-elora-sbar-ready')) return;
    bar.setAttribute('data-elora-sbar-ready', '');

    var past = false;
    var blocked = false;
    var bannerOpen = false; /* Noom 2026-09-12: Shopify's cookie banner sits fixed at the bottom and covers the bar */

    function sync() {
      var on = past && !blocked && !bannerOpen;
      bar.classList.toggle('is-on', on);
      /* keep the hidden bar out of the tab order and away from assistive tech */
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = bar.querySelector('[data-elora-sbar-btn]');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }

    applySelection(bar, Elora.selection);
    var onSelection = function (e) { applySelection(bar, e.detail); };
    document.addEventListener('elora:selection', onSelection);

    var trigger = buyTarget();
    var io, io2, onScroll, onClick;

    if (trigger && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sync();
        },
        { threshold: 0 }
      );
      io.observe(trigger);
      /* Noom 2026-09-12: an instant jump past the buy box (anchor link with reduced motion, script scroll) never lets
         the trigger intersect, so the observer stays silent and the bar would stay hidden; a cheap scroll check
         (one rect read, sync only on change) covers that case */
      onScroll = function () {
        var r = trigger.getBoundingClientRect();
        var p = r.bottom < 0;
        if (p !== past) { past = p; sync(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      onScroll = function () {
        past = window.pageYOffset > window.innerHeight * 0.6;
        sync();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if ('IntersectionObserver' in window) {
      var zones = [
        document.querySelector('#buy'),
        document.querySelector('[data-elora-buy]'),
        document.querySelector('#buy-band'),
        document.querySelector('#community'), /* community CTA has its own Order button (2026-09-04) */
        document.querySelector('.footer'),
        document.querySelector('footer')
      ].filter(function (z, i, all) {
        return z && all.indexOf(z) === i;
      });

      if (zones.length) {
        var visible = [];
        io2 = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              var i = visible.indexOf(e.target);
              if (e.isIntersecting) {
                if (i === -1) visible.push(e.target);
              } else if (i > -1) {
                visible.splice(i, 1);
              }
            });
            blocked = visible.length > 0;
            sync();
          },
          { threshold: 0 }
        );
        zones.forEach(function (z) {
          io2.observe(z);
        });
      }
    }
    /* Noom 2026-09-12: while the cookie banner (#shopify-pc__banner) is open the bar stays hidden, so the consent
       decision is never covered by the CTA and the CTA is never buried under the banner; the bar returns after the
       decision (the banner element is removed or hidden). One cheap check per DOM mutation. */
    var mo;
    function checkBanner() {
      var b = document.getElementById('shopify-pc__banner');
      var open = !!(b && b.offsetHeight > 0 && b.offsetWidth > 0);
      if (open !== bannerOpen) { bannerOpen = open; sync(); }
    }
    checkBanner();
    if ('MutationObserver' in window) {
      mo = new MutationObserver(checkBanner);
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    }
    sync();

    /* the Theme Editor re-renders the buy box without this bar: the observed nodes go stale */
    var btn = bar.querySelector('[data-elora-sbar-btn]');
    bar.eloraSbarTeardown = function () {
      if (io) io.disconnect();
      if (io2) io2.disconnect();
      if (mo) mo.disconnect();
      if (onScroll) window.removeEventListener('scroll', onScroll);
      if (btn && onClick) btn.removeEventListener('click', onClick);
      document.removeEventListener('elora:selection', onSelection);
      bar.removeAttribute('data-elora-sbar-ready');
    };

    if (btn) {
      onClick = function () {
        /* Kamil 2026-09-04: pressed state = ink for the length of the fly-to-cart flight */
        btn.classList.add('is-pressed');
        window.setTimeout(function () { btn.classList.remove('is-pressed'); }, 1100);
        var t = buyTarget();
        /* Submit the real product form (Dawn's product-form.js opens the cart drawer);
           fall back to scrolling when the product is unavailable or the form is missing. */
        var form = t && t.querySelector('form[action*="/cart/add"]');
        var submit = form && form.querySelector('[type="submit"][name="add"]');
        if (form && submit && !submit.disabled) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submit); else submit.click();
          return;
        }
        if (t) t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      };
      btn.addEventListener('click', onClick);
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll('[data-elora-sbar]')).forEach(initRoot);
    if (root.matches && root.matches('[data-elora-sbar]')) initRoot(root);
  }

  Elora.stickyBar = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  function reset(bar) {
    if (bar.eloraSbarTeardown) bar.eloraSbarTeardown();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    /* a bar outside the re-rendered section watches nodes that may have just been replaced */
    Array.prototype.slice.call(document.querySelectorAll('[data-elora-sbar]')).forEach(function (bar) {
      if (target === document || !target.contains(bar)) { reset(bar); initRoot(bar); }
    });
    init(target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelectorAll) Array.prototype.slice.call(e.target.querySelectorAll('[data-elora-sbar]')).forEach(reset);
  });
})();
